import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=2365c41a"
import script from "./ShareButtons.vue?vue&type=script&lang=js"
export * from "./ShareButtons.vue?vue&type=script&lang=js"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=2365c41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports